import * as React from "react";
import { useDispatch } from "react-redux";

import { ActivityActions } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";
import { LocalizerContext } from "@com.mgmtp.a12.utils/utils-localization-react/lib/main";
import { ButtonGroup } from "@com.mgmtp.a12.widgets/widgets-core/lib/button-group/main/button-group.view";
import { Button } from "@com.mgmtp.a12.widgets/widgets-core/lib/button/main/button.view";
import { ModalNotification } from "@com.mgmtp.a12.widgets/widgets-core/lib/modal-notification/main/modal-notification.view";

import { RESOURCE_KEYS } from "../../../localization";
import { getViewHtmlId } from "../../focusHandling/sagas";

import { emailConfirmation } from "../actions";

const MODAL_RESOURCE_KEYS = RESOURCE_KEYS.features.modals;

export function CustomEmailConfirmContainer(props: View) {
	const { activityId } = props;

	const dispatch = useDispatch();
	const { localizer } = React.useContext(LocalizerContext);

	const onAbbrechenClick = React.useCallback(() => {
		dispatch(emailConfirmation({ isConfirmed: false }));
		dispatch(ActivityActions.cancel({ activityId: activityId }));
	}, [dispatch, activityId]);

	const onConfirmClick = React.useCallback(() => {
		dispatch(emailConfirmation({ isConfirmed: true }));
		dispatch(ActivityActions.cancel({ activityId: activityId }));
	}, [dispatch, activityId]);

	return (
		<ModalNotification
			id={getViewHtmlId(activityId)}
			variant="warning"
			onClose={onAbbrechenClick}
			title={localizer({ key: MODAL_RESOURCE_KEYS.title.emailConfirmModal })}
			footer={
				<ButtonGroup alignment="right">
					<Button
						label={localizer({ key: MODAL_RESOURCE_KEYS.button.abbrechenUndZurueck })}
						secondary
						onClick={onAbbrechenClick}
					/>
					<Button
						label={localizer({ key: MODAL_RESOURCE_KEYS.button.bestaetigen })}
						destructive
						primary
						onClick={onConfirmClick}
					/>
				</ButtonGroup>
			}
		>
			<p>{localizer({ key: MODAL_RESOURCE_KEYS.content.emailConfirmModal })}</p>
			<p>{localizer({ key: MODAL_RESOURCE_KEYS.content.emailConfirmModalSicher })}</p>
		</ModalNotification>
	);
}
